import React from 'react';

import { OpenConvalidaResponse, Group, Task } from 'models/response';

import Hierarchy from 'components/Hierarchy';
import Close from './close';

interface Props {
  title: string;
  response: OpenConvalidaResponse;
  setSelectedTask: (isActive?: boolean, task?: Task) => void;
  setSelectedGroups: (groups: Group[]) => void;
}

const columns = [
  { accessor: 'username', Header: 'User' },
  { accessor: 'name', Header: 'Name' },
];

const searchTypeValues: { value: string; label: string; parent: 'one' | 'two' | 'three' | 'table' }[] = [
  { value: 'task', label: 'Task', parent: 'one' },
  { value: 'group', label: 'Group', parent: 'two' },
  { value: 'user', label: 'User', parent: 'table' },
];

const NextTask = ({ title, response, setSelectedTask, setSelectedGroups }: Props) => {
  const nextTasks = response.referenceNextTask?.referenceNextTask;

  if (response.referenceNextTask?.lastTask) {
    return <Close response={response} />;
  } else {
    return (
      <Hierarchy
        title={title}
        hasSearch
        searchTypeValues={searchTypeValues}
        parentsOne={nextTasks}
        parentOneName="taskName"
        parentOneId="idTask"
        parentOneSelection={(value: any) => {
          setSelectedTask && setSelectedTask(value, value);
          setSelectedGroups && setSelectedGroups([]);
        }}
        preSelectedParentOne={nextTasks?.length === 1 && nextTasks[0].taskAction?.idAction === 2 ? nextTasks[0] : null}
        parentOneChild="groups"
        parentTwoName="groupName"
        parentTwoId="idGroup"
        parentTwoSelection={(isActive?: boolean, value?: any) => {
          setSelectedGroups && setSelectedGroups(value);
        }}
        parentTwoChild="users"
        parentTwoHasTable={true}
        idRowTable="idUser"
        columns={columns}
        tableValueName="username"
        tableValueNameTwo="name"
      />
    );
  }
};

export default NextTask;
